export default __webpack_public_path__ + "static/media/5.b0b31ca3.webp";